// Copyright (C) 2021 Bystronic Laser AG

export enum DeviceModelType {
  Bending = 'bending',
  Laser = 'laser',
  Tubes = 'tubes',
}

export class DeviceBaseModel {
  constructor(
    public deviceBaseModelId: string,
    public name: string,
    public type: DeviceModelType,
    public code1: string,
  ) {}
}
